import { customAxiosBE } from "../config";

// ==================== PARKING SERVICES CRUD ====================

/**
 * Dohvata sve parking usluge za operatora
 */
export async function getAllParkingServicesAPI() {
    return customAxiosBE.get(`/parking-services`);
}

/**
 * Dohvata aktivne parking usluge
 */
export async function getActiveParkingServicesAPI() {
    return customAxiosBE.get(`/parking-services/active`);
}

/**
 * Dohvata parking uslugu po ID-u
 */
export async function getParkingServiceByIdAPI(id) {
    return customAxiosBE.get(`/parking-services/${id}`);
}

/**
 * Kreira novu parking uslugu
 */
export async function createParkingServiceAPI(data) {
    return customAxiosBE.post(`/parking-services`, data);
}

/**
 * Azurira parking uslugu
 */
export async function updateParkingServiceAPI(id, data) {
    return customAxiosBE.put(`/parking-services/${id}`, data);
}

/**
 * Brise parking uslugu (soft delete)
 */
export async function deleteParkingServiceAPI(id) {
    return customAxiosBE.delete(`/parking-services/${id}`);
}

// ==================== PRICING ====================

/**
 * Dohvata sve cene za parking uslugu
 */
export async function getParkingServicePricingsAPI(parkingServiceId) {
    return customAxiosBE.get(`/parking-services/${parkingServiceId}/pricings`);
}

/**
 * Dodaje cenu za parking uslugu
 */
export async function addParkingServicePricingAPI(parkingServiceId, data) {
    return customAxiosBE.post(`/parking-services/${parkingServiceId}/pricings`, data);
}

/**
 * Azurira cenu
 */
export async function updateParkingServicePricingAPI(parkingServiceId, pricingId, data) {
    return customAxiosBE.put(`/parking-services/${parkingServiceId}/pricings/${pricingId}`, data);
}

/**
 * Brise cenu
 */
export async function deleteParkingServicePricingAPI(parkingServiceId, pricingId) {
    return customAxiosBE.delete(`/parking-services/${parkingServiceId}/pricings/${pricingId}`);
}

// ==================== TIME CONFIG ====================

/**
 * Dohvata sve vremenske konfiguracije za parking uslugu
 */
export async function getParkingServiceTimeConfigsAPI(parkingServiceId) {
    return customAxiosBE.get(`/parking-services/${parkingServiceId}/time-configs`);
}

/**
 * Dodaje vremensku konfiguraciju
 */
export async function addParkingServiceTimeConfigAPI(parkingServiceId, data) {
    return customAxiosBE.post(`/parking-services/${parkingServiceId}/time-configs`, data);
}

/**
 * Azurira vremensku konfiguraciju
 */
export async function updateParkingServiceTimeConfigAPI(parkingServiceId, configId, data) {
    return customAxiosBE.put(`/parking-services/${parkingServiceId}/time-configs/${configId}`, data);
}

/**
 * Brise vremensku konfiguraciju
 */
export async function deleteParkingServiceTimeConfigAPI(parkingServiceId, configId) {
    return customAxiosBE.delete(`/parking-services/${parkingServiceId}/time-configs/${configId}`);
}

// ==================== KOMBINOVANI UPITI ====================

/**
 * Dohvata kompletnu konfiguraciju (cena + vreme) za parking uslugu
 */
export async function getParkingFullConfigAPI(parkingServiceId, locationId, date) {
    const params = new URLSearchParams({ parkingServiceId });
    if (locationId) params.append('locationId', locationId);
    if (date) params.append('date', date);
    return customAxiosBE.get(`/parking-services/full-config?${params}`);
}

/**
 * Dohvata sve parking usluge sa cenama za cenovnik
 */
export async function getParkingServicesByRateCardAPI(rateCardId, locationId, date) {
    const params = new URLSearchParams();
    if (locationId) params.append('locationId', locationId);
    if (date) params.append('date', date);
    const queryString = params.toString();
    return customAxiosBE.get(`/parking-services/by-rate-card/${rateCardId}${queryString ? '?' + queryString : ''}`);
}

/**
 * Dohvata cene po cenovniku (za admin prikaz)
 */
export async function getParkingPricingsByRateCardAPI(rateCardId) {
    return customAxiosBE.get(`/parking-services/pricings/by-rate-card/${rateCardId}`);
}
